export const enum RouteType {
    API = 'API',
    Backend = 'Backend',
    Frontend = 'Frontend',
    Redirect = 'Redirect',
}
